import React, { useEffect } from 'react';

import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';

import DialogViewWrapper from 'components/DialogViewWrapper';
import Loader from 'components/Loader';
import WorkplaceDetailsCard from 'components/WorkplaceDetailsCard/WorkplaceDetailsCard';
import useGetWorkplaceFullData from 'hooks/useGetWorkplaceFullData/useGetWorkplaceFullData';
import general_messages from 'messages/general_messages';
import workplace_messages from 'messages/workplace_messages';
import { useAuthContext } from 'reactContext/AuthContext';
import PATHS from 'router/PATHS';

const SingleWorkplacePage: React.FC = () => {
  const { workplace_id } = useParams() as unknown as { workplace_id: number };
  const { t } = useTranslation();
  const history = useHistory();
  // @ts-ignore
  const { updateUserData } = useAuthContext();

  const { data, isLoading, isError, isNotFound, refreshData } = useGetWorkplaceFullData(Number(workplace_id));

  useEffect(() => {
    if (!isNotFound) return;

    const refreshUserAndRedirect = async () => {
      try {
        await updateUserData();
      } finally {
        history.replace(PATHS.WORKPLACES);
      }
    };

    refreshUserAndRedirect();
  }, [history, isNotFound, updateUserData]);

  const onBack = () => history.push(PATHS.WORKPLACES);

  let content: React.ReactElement;
  if (isLoading || isNotFound) {
    content = <Loader inner />;
  } else if (isError || !data) {
    content = <Typography color='error'>{t(general_messages.something_went_wrong)}</Typography>;
  } else {
    content = (
      <WorkplaceDetailsCard refreshData={refreshData} templateValues={data.templateValues} workplaceBaseData={data.workplaceBaseData} />
    );
  }

  return (
    <DialogViewWrapper contentSize='640px' noCardPadding onBack={onBack} title={t(workplace_messages.singleWorkplace.pageTitle)}>
      {content}
    </DialogViewWrapper>
  );
};

export default SingleWorkplacePage;
